import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import WhatWeDo from "@/pages/WhatWeDo";
import GetInvolved from "@/pages/GetInvolved";
import News from "@/pages/News";
import Contact from "@/pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/what-we-do" element={<WhatWeDo />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
